<app-manax-sidebar></app-manax-sidebar>